import { Injectable } from "@angular/core";
import { ConnectionBackend, RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers } from "@angular/http";
import { Observable, Subject } from "rxjs/Rx";
import { ErrorObservable } from "rxjs/Observable/ErrorObservable";
import { LocalStorageService } from 'angular-2-local-storage';
import { LoaderService, HttpIntegrationService } from './index';

@Injectable()
export class InterceptedHttp extends Http {

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions, private localStorageService: LocalStorageService, private loaderService: LoaderService, private httpIntegrationService: HttpIntegrationService) {
        super(backend, defaultOptions);
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        this.showLoader();

        return super.get(url, this.getRequestOptionArgs(options))
            .do((res: Response) => {
                this.onSuccess(res);
            }, (error: any) => {
                this.onError(error);
            })
            .finally(() => {
                this.onEnd();
            });
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        this.showLoader();

        return super.post(url, body, this.getRequestOptionArgs(options))
            .do((res: Response) => {
                this.onSuccess(res);
            }, (error: any) => {
                this.onError(error);
            })
            .finally(() => {
                this.onEnd();
            });
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        this.showLoader();

        return super.put(url, body, this.getRequestOptionArgs(options))
            .do((res: Response) => {
                this.onSuccess(res);
            }, (error: any) => {
                this.onError(error);
            })
            .finally(() => {
                this.onEnd();
            });
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        this.showLoader();

        return super.delete(url, this.getRequestOptionArgs(options))
            .do((res: Response) => {
                this.onSuccess(res);
            }, (error: any) => {
                this.onError(error);
            })
            .finally(() => {
                this.onEnd();
            });
    }

    private getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }

        if (!options.withCredentials)
            this.createAuthorizationHeader(options.headers);

        return options;
    }

    private createAuthorizationHeader(headers: Headers) {
        if (this.localStorageService.get('id_token') != null) {
            headers.append('Authorization', this.localStorageService.get<string>('id_token'));
        }
    }

    private onSuccess(res: Response): void {
        console.log('Request successful');
    }

    private onError(res: Response): void {
        console.log('Error, status code: ' + res.status);
        this.httpIntegrationService.error(res);
    }

    private onEnd(): void {
        this.hideLoader();
    }

    private showLoader(): void {
        this.loaderService.show();
    }

    private hideLoader(): void {
        this.loaderService.hide();
    }
}